/*
 * Color-swatch hover: when a shopper hovers (or focuses) a colour swatch on a
 * product card, cross-fade the card image to that colour's variant image.
 * Degrades gracefully: swatches with no variant image do nothing.
 * Works in best-sellers (product-card) and collection grids (product-card-grid),
 * and coexists with the grid card's hover image slideshow (overlay sits on top).
 */
(function () {
  'use strict';

  function bindCard(card) {
    if (card.dataset.swHoverBound) return;
    var overlay = card.querySelector('[data-card-hover-img]');
    var swatches = card.querySelectorAll('[data-color-swatch][data-variant-image]');
    if (!overlay || !swatches.length) return;
    card.dataset.swHoverBound = '1';

    function show(src) {
      if (!src) return;
      if (overlay.getAttribute('src') !== src) overlay.setAttribute('src', src);
      overlay.style.opacity = '1';
    }
    function hide() { overlay.style.opacity = '0'; }

    swatches.forEach(function (sw) {
      var src = sw.getAttribute('data-variant-image');
      sw.addEventListener('mouseenter', function () { show(src); });
      sw.addEventListener('focus', function () { show(src); });
      // Leaving a swatch (while still on the card) hides the colour overlay so the
      // lifestyle hover image shows through again.
      sw.addEventListener('mouseleave', hide);
      sw.addEventListener('blur', hide);
    });
    card.addEventListener('mouseleave', hide);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-swatch-hover-card]')) bindCard(scope);
    scope.querySelectorAll('[data-swatch-hover-card]').forEach(bindCard);
  }

  function init() { scan(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
